export default __webpack_public_path__ + "static/media/logo-full.d91246d3.png";